import { ApolloClient } from '@apollo/client'
import auth from './auth'
import cache from './cache'
import link from './link'
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev'

if (process.env.NODE_ENV !== 'production') {
	// Adds messages only in a dev environment
	loadDevMessages()
	loadErrorMessages()
}

const client = new ApolloClient({
	cache,
	resolvers: {},
	link: auth.concat(link) as any,
	name: 'wolfdanepug',
	version: '1.0.0',
	queryDeduplication: true,
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'cache-first'
		},
		query: {
			fetchPolicy: 'cache-first'
		}
	}
})

export default client
